import { cn } from "@/utils";

const classNames = {
    primary: 'bg-primary hover:bg-transparent text-white hover:text-primary border border-primary',
    secondary: 'bg-primary/10 text-primary hover:bg-primary hover:text-primary-white',
    gray: 'bg-gray4/10 text-gray4 hover:bg-gray4 hover:text-primary-white border border-transparent',
    outline: 'bg-transparent text-primary border border-primary hover:bg-primary hover:text-primary-white',
    dark: 'bg-gray3 text-primary-white hover:bg-gray3/10 hover:text-gray3',
    custom: ''
}

const Button = ({
    className,
    style,
    children,
    btnType = 'primary',
    ...props
}: React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    btnType?: 'primary' | 'secondary' | 'gray' | 'custom' | 'outline' | 'dark';
}) => {

    return (
        <button className={cn(
            classNames[btnType],
            ' py-1 md:py-1.5 px-0.5 text-center text-[0.75rem] md:text-[0.85rem] font-medium rounded-[3px] transition-colors duration-500',
            className,
        )} style={style} {...props}>
            {children}
        </button>
    )
}

export default Button